<template>
	<div>
		<div>
			<div class="headline" v-html="status" :class="statusColor" />
			<v-progress-circular :indeterminate="loading" color="lime" :size="20"></v-progress-circular>
			<span class="caption ml-2" v-html="refreshLabel" />
		</div>
		<div class="title my-3 info--text">{{sysConfig.processingCount}} active workers</div>
		<v-row class="my-3">
			<v-col cols="2" class="pt-6">
				<v-btn color="primary" title="Begin Shutdown" :disabled="errors.any()" v-if="sysConfig.status === 'Online'" @click="changeStatus('ShuttingDown')">
					Begin Shutdown
				</v-btn>
				<v-btn color="primary" title="Begin Shutdown" v-else @click="changeStatus('Online')">
					Go Online
				</v-btn>
			</v-col>
			<v-col cols="4">
				<v-text-field label="Notification Email" v-model="email" name="email" v-if="sysConfig.status === 'Online'"
					v-validate="'email'" :error-messages="errors.collect('email')"></v-text-field>
			</v-col>
		</v-row>
		<div class="body-1">
			<p>
				System status affects the monitoring of workers and the ability to process of jobs. It does not control whether workers are running.
			</p>
			<p>
				Shutdown will put the system into <code class="amber--text">Shutting Down</code> status, tell all workers to stop accepting new jobs, then wait until
				all current jobs are complete before changing status to <code class="red--text">Offline</code>. If a notification email address is provided then an
				email will be sent when the system changes from Shutting Down to <code class="red--text">Offline</code>.
			</p>
			<p>
				When the system is <code class="red--text">Offline</code> no jobs will be picked up by workers and the status of the workers will not be checked.
			</p>
			<p>
				When the system is <code class="green--text">Online</code> the workers will be monitored for uptime and the workers will accept new jobs.
			</p>
		</div>
	</div>
</template>

<script>
import api from "../api";

export default {
	data() {
		return {
			sysConfig: {},
			loading: false,
			intervalTimer: null,
			intervalSec: 10,
			intervalCountdown: 10,
			email: null,
			requestComplete: true,
		};
	},
	computed: {
		status() {
			if (this.sysConfig.status === "ShuttingDown") {
				return "Shutting Down";
			}
			return this.sysConfig.status;
		},
		statusColor() {
			if (this.sysConfig.status === "ShuttingDown") {
				return "amber--text";
			}
			if (this.sysConfig.status === "Offline") {
				return "red--text";
			}
			return "green--text";
		},
		refreshLabel() {
			return this.loading ? "Refreshing" : `Refresh in ${this.intervalCountdown}`;
		},
	},
	created() {
		this.refresh();
	},
	methods: {
		startInterval() {
			this.intervalCountdown = this.intervalSec;
			this.interval();
			this.intervalTimer = setInterval(this.interval, 1000);
		},
		stopInterval() {
			clearInterval(this.intervalTimer);
		},
		interval() {
			this.intervalCountdown -= 1;
			if (this.intervalCountdown === 0) {
				this.refresh();
			}
		},
		refresh() {
			this.stopInterval();
			this.loading = true;
			api.system().then((r) => {
				this.sysConfig = r.data;
				this.loading = false;
				this.startInterval();
			})
				.catch((e) => { this.showError(e); });
		},
		changeStatus(newStatus) {
			this.stopInterval();
			this.loading = false;
			api.systemChange({ status: newStatus, notificationEmail: this.email }).then(() => {
				this.showToast("success", "Command sent");
				this.refresh();
			})
				.catch((e) => { this.showError(e); });
		},
	},
	beforeDestroy() {
		if (this.intervalTimer) { clearInterval(this.intervalTimer); }
	},
};
</script>
